//PACKS
import React from "react";
import { useSpring, animated } from "react-spring";

//STYLES
import "../styles/productInfoDesktop.scss";

export default function ProductInfoDesktop(props) {
  const productInfoPopup = useSpring({
    from: { transform: "translatey(50px)", opacity: 0 },
    to: { transform: "translatey(0)", opacity: 1 },
    delay: 400,
  });
  return (
    <div className="productInfoDesktopContainer">
      <animated.div style={productInfoPopup} className="productInfo">
        <h2 className="productInfoTitle">{props.product.name}</h2>
        <p className="productInfoParagraph">{props.product.description}</p>
        {props.product.link ? (
          <a target="_blank" href={props.product.link}>
            See more
          </a>
        ) : (
          <></>
        )}
      </animated.div>
      <div style={{ backgroundImage: `url(${props.product.picture})` }} />
    </div>
  );
}
